import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServiceListRoutingModule } from './service-list-routing.module';
import { ServiceListComponent } from './service-list.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxDataGridModule } from 'devextreme-angular';


@NgModule({
  declarations: [
    ServiceListComponent
  ],
  imports: [
    CommonModule,
    ServiceListRoutingModule,
    MdbGlobalModule,
    DxDataGridModule
  ],
  exports: [ServiceListComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ServiceListModule { }
